import React from "react"
import PropTypes from "prop-types"

import { css } from "@emotion/react"
import { useBreakpoint } from "gatsby-plugin-breakpoints"

import useMixins, { fontSize, globalColors } from "../css-functions"
import Image from "../image"

import SvgListmarkerHexagon from "../../assets/svg/listmarker_hexagon.svg"

import Cloud from "../../components/cloud"

const LearnFeatures = ({
  pcTitle,
}) => {
  const bp = useBreakpoint()
  const mixins = useMixins()

  const style = {
    section: css`
      ${mixins.default.sectionStyle}
    `,
    title: css`
      padding-bottom: 9px;
      display: flex;
      align-items: center;
      position: relative;
      border-bottom: 1px solid ${globalColors.gold};
      ${bp.isTablet ? fontSize(20) : fontSize(16)}
      font-weight: 700;
    `,
    svgWrapper: css`
      margin-right: 8px;
      display: inline-block;
      width: ${bp.isTablet ? '24px' : '20px'};
      height: ${bp.isTablet ? '24px' : '20px'};
      flex-shrink: 0;
    `,
    content: css`
      ${mixins.default.contentStyle}
    `,
    text: css`
      ${mixins.default.textStyle}
    `,
    imgWrapper: css`
      display: flex;
      position: relative;
    `,
    imgWrapperInnerR: css`
      margin: ${ bp.isTablet ? '0 -100px 0 auto' : '0 0 0 auto' };
      width: ${ bp.isTablet ? '480px' : '64%' };
    `,
    imgWrapperInnerL: css`
      margin: ${ bp.isTablet ? '0 auto 0 -100px' : '0 auto 0 0' };
      width: ${ bp.isTablet ? '480px' : '64%' };
    `,
    cloudWrapper: css`
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    `, 
  }

  const StyledTitle = ( title ) => {
    return (
      <h2 css={style.title}>
        <span css={style.svgWrapper}>
          <SvgListmarkerHexagon />
        </span>
        <span>{ title }</span>
      </h2>
    )
  }

  return (
    <>
      { pcTitle }
      <section css={style.section}>
        {StyledTitle('月謝制度・お免状制度')}
        <div css={style.content}>
          <p css={style.text}>技術を身につけていくと様々な盆石を打てるようになり、表現の幅も広がっていきます。盆石技術の段階ごとにお免状を授与いたします。料金など詳細は各教室までお問い合わせください。</p>
          <div css={style.imgWrapper}>
            <div css={style.imgWrapperInnerR}>
              <Image filename="learn_img1.png" />
            </div>
            <div css={ style.cloudWrapper }>
              { bp.isMiddle
                ?
                  <>
                    <Cloud
                      filename="cloud_1_1.png"
                      top="60px"
                      left="-200px"
                    />
                    <Cloud
                      filename="cloud_1_2.png"
                      top="-30px"
                      right="-100px"
                    />
                    <Cloud
                      filename="cloud_1_3.png"
                      bottom="0"
                      left="-440px"
                    />
                    <Cloud
                      filename="cloud_1_4.png"
                      right="-380px"
                      bottom="0"
                    />
                  </>
                :
                  <>
                    <Cloud
                      filename="cloud_1_1.png"
                      top="-10px"
                      left="-80px"
                      imgWidth="240px"
                    />
                    <Cloud
                      filename="cloud_1_4.png"
                      right="-170px"
                      bottom="-60px"
                      imgWidth="360px"
                    />
                  </>
              }
            </div>
          </div>
        </div>
      </section>
      <section css={style.section}>
        {StyledTitle('どなたでも家元教室に通えます')}
        <div css={style.content}>
          <p css={style.text}>xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx</p>
          <div css={style.imgWrapper}>
            <div css={style.imgWrapperInnerL}>
              <Image filename="learn_img2.png" />
            </div>
            <div css={ style.cloudWrapper }>
              { bp.isMiddle
                ?
                  <>
                    <Cloud
                      filename="cloud_2_1.png"
                      top="20px"
                      left="-360px"
                    />
                    <Cloud
                      filename="cloud_2_2.png"
                      top="50px"
                      right="-220px"
                    />
                    <Cloud
                      filename="cloud_2_3.png"
                      bottom="-70px"
                      left="-40px"
                    />
                    <Cloud
                      filename="cloud_2_4.png"
                      right="-440px"
                      bottom="60px"
                    />
                  </>
                :
                  <>
                    <Cloud
                      filename="cloud_2_1.png"
                      top="-30px"
                      left="-320px"
                    />
                    <Cloud
                      filename="cloud_2_2.png"
                      right="-80px"
                      bottom="-50px"
                      imgWidth="260px"
                    />
                    <Cloud
                      filename="cloud_2_4.png"
                      top="-20px"
                      right="-100px"
                      imgWidth="280px"
                    />
                  </>
              }
            </div>
          </div>
        </div>
      </section>
      <section css={style.section}>
        {StyledTitle('まずは体験教室へ')}
        <div css={style.content}>
          <p css={style.text}>ご興味がある方は、気軽にお近くの教室まで足を運んでみてください。実際に打ってみることで、お盆石の世界を感じていただけます。</p>
          <div css={style.imgWrapper}>
            <div css={style.imgWrapperInnerR}>
              <Image filename="learn_img3.png" />
            </div>
            <div css={ style.cloudWrapper }>
              { bp.isMiddle
                ?
                  <>
                    <Cloud
                      filename="cloud_3_1.png"
                      top="30px"
                      left="-380px"
                    />
                    <Cloud
                      filename="cloud_3_2.png"
                      top="130px"
                      right="-400px"
                    />
                    <Cloud
                      filename="cloud_3_3.png"
                      bottom="0px"
                      left="-200px"
                    />
                  </>
                :
                  <>
                    <Cloud
                      filename="cloud_3_2.png"
                      top="-10px"
                      left="-100px"
                      imgWidth="300px"
                    />
                    <Cloud
                      filename="cloud_3_3.png"
                      right="-100px"
                      bottom="-100px"
                      imgWidth="320px"
                    />
                  </>
              }
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

LearnFeatures.propTypes = {
  pcTitle: PropTypes.object,
}

export default LearnFeatures